var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"spinner",staticClass:"hollow-dots-spinner",class:{ 'is-masked': _vm.isMasked, 'is-active': _vm.isActive }},[_c('div',{staticClass:"hollow-dots-spinner__overlay",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }